import { get } from "src/services/api";

// The draft's pending changes: config vs `base` ("build" | "live"), knowledge rows vs live.
export const fetchConfigReview = async (assistantId, base, { signal } = {}) =>
  await get({ endpoint: `assistants/${assistantId}/config/review`, params: { base }, signal });
